<app-basic-page [pageTitle]="'Workspace Settings'">
  <div class="vertical-large full-width body-content">
    <div class="vertical basic-card-color blue-background full-width">
      <div class="vertical">
        <div class="title">Workspace Name</div>
        <input nz-input placeholder="Workspace Name" nzSize="large" [(ngModel)]="workspace().title" />
      </div>

      <button class="fit-content right" nz-button nzType="primary" nzSize="large" (click)="onSaveClick()">Save</button>
    </div>

    <div class="vertical basic-card-color red-background full-width">
      <div class="vertical">
        <div class="title">Sales Cycle</div>
        <div class="horizontal">
          <app-sales-cycle-bar
            [changeCurrentSalesCycle]="false"
            (salesCycleChange)="onSalesCycleChange($event)"
          ></app-sales-cycle-bar>

          <button
            class="fit-content center"
            nz-button
            nzType="default"
            nzSize="large"
            (click)="onConfigSalesCycleClick()"
          >
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">settings</span>
            Config
          </button>
        </div>
        @if (selectedSalesCycle()) {
          <div class="vertical-large">
            <div class="vertical">
              <div class="field-name">Id</div>
              <input nz-input placeholder="Id" nzSize="large" [(ngModel)]="selectedSalesCycle()!.id" />
            </div>

            <div class="vertical">
              <div class="field-name">Name</div>
              <input nz-input placeholder="Title" nzSize="large" [(ngModel)]="selectedSalesCycle()!.title" />
            </div>

            <div class="vertical">
              <div class="field-name">Description</div>
              <textarea
                nz-input
                placeholder="Description"
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="selectedSalesCycle()!.description"
              ></textarea>
            </div>
          </div>
        }
      </div>

      <button class="fit-content right" nz-button nzType="primary" nzSize="large" (click)="onSaveClick()">Save</button>
    </div>

    <div class="vertical basic-card-color magenta-background full-width">
      <div class="vertical">
        <div class="title horizontal seperate">
          <div>Report</div>
          <!-- <button nz-button nzType="default" nzSize="small" (click)="onCreateReportClick()">
            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
            Create Report
          </button> -->
        </div>
        <nz-table #basicTable [nzData]="listOfReportData" [nzShowPagination]="false">
          <thead>
            <tr>
              <th>Name</th>
              <th>Interval</th>
              <th>Send to</th>
              <th>Status</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            @for (item of basicTable.data; track item) {
              <tr>
                <td>Weekly Report</td>
                <td>Weekly</td>
                <td>
                  <div class="vertical">
                    @for (email of getSendToEmailList(); track i; let i = $index) {
                      <div class="horizontal seperate">
                        <div>{{ email }}</div>
                        <div>
                          <button nz-button nzType="default" nzSize="small" (click)="onRemoveEmailClick(i)">
                            <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                          </button>
                        </div>
                      </div>
                    }

                    <button
                      class="fit-content"
                      nz-button
                      nzType="default"
                      nzSize="small"
                      nz-popover
                      nzPopoverTitle="Add Email"
                      [(nzPopoverVisible)]="isAddEmailVisible"
                      nzPopoverTrigger="click"
                      [nzPopoverContent]="addEmailContentTemplate"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">email</span>
                      Add Email

                      <ng-template #addEmailContentTemplate>
                        <app-text-popup
                          [title]="'Email'"
                          (cancel)="onAddEmailCancel()"
                          (save)="onAddEmailClick($event)"
                        ></app-text-popup>
                      </ng-template>
                    </button>
                  </div>
                </td>
                <td>
                  <div class="vertical">
                    @if (getWeeklyReport().status === HourlyTaskStatus.running) {
                      <nz-tag nzMode="checkable" (click)="onRunningClick()" class="fit-content" nzColor="success">
                        <span nz-icon nzType="caret-right"></span>
                        <span>Running</span>
                      </nz-tag>
                    } @else {
                      <nz-tag nzMode="checkable" (click)="onPausedClick()" class="fit-content" nzColor="warning">
                        <span nz-icon nzType="pause"></span>
                        <span>Paused</span>
                      </nz-tag>
                    }

                    <button nz-button nzType="default" nzSize="small" (click)="onSendWeeklyReportClick()">
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">description</span>
                      Send Weekly Report
                    </button>
                  </div>
                </td>
                <!-- <td>
                  <div class="vertical">
                    <button nz-button nzType="default" nzSize="small" (click)="onEditReportClick()">
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
                      Edit
                    </button>
                  </div>
                </td> -->
              </tr>
            }
          </tbody>
        </nz-table>
      </div>
    </div>

    <div class="vertical basic-card-color volcano-background full-width">
      <div class="title"><img style="width: 20px" src="/assets/images/logos/hubspot-1.svg" /> HubSpot</div>

      <div class="horizontal-large">
        <button
          [nzLoading]="isConnectedToHubSpot() === undefined"
          nz-button
          nzType="default"
          nzSize="large"
          nz-popover
          nzPopoverTitle="Connect HubSpot"
          [(nzPopoverVisible)]="isHubSpotVisible"
          nzPopoverTrigger="click"
          [nzPopoverContent]="hubSpotContentTemplate"
        >
          @if (isConnectedToHubSpot() === true) {
            <span nz-icon style="font-size: 24px" class="material-symbols-rounded">check</span>
            Connected
          } @else if (isConnectedToHubSpot() === false) {
            Connect
          }

          <ng-template #hubSpotContentTemplate>
            <app-text-popup
              [title]="'HubSpot Access Token'"
              [descriptionMarkdown]="connectHubSpotDescriptionMarkdown"
              (cancel)="onConnectHubSpotCancel()"
              (save)="onConnectHubSpotClick($event)"
            ></app-text-popup>
          </ng-template>
        </button>

        <button nz-button nzType="primary" nzSize="large" (click)="onSyncCompaniesClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">sync</span>
          Sync Companies
        </button>

        <button nz-button nzType="primary" nzSize="large" (click)="onSyncCustomersClick()">
          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">sync</span>
          Sync Customers
        </button>
      </div>
    </div>

    <div class="vertical basic-card-color gold-background full-width">
      <div class="title">Slack</div>

      <div class="horizontal-large">
        <button
          [nzLoading]="isConnectedToSlack() === undefined"
          nz-button
          nzType="default"
          nzSize="large"
          nz-popover
          nzPopoverTitle="Connect Slack"
          [(nzPopoverVisible)]="isSlackVisible"
          nzPopoverTrigger="click"
          [nzPopoverContent]="slackContentTemplate"
        >
          @if (isConnectedToSlack() === true) {
            <span nz-icon style="font-size: 24px" class="material-symbols-rounded">check</span>
            Connected
          } @else if (isConnectedToSlack() === false) {
            Connect
          }

          <ng-template #slackContentTemplate>
            <app-text-popup
              [title]="'Slack Bot Token'"
              [descriptionMarkdown]="connectSlackDescriptionMarkdown"
              (cancel)="onConnectSlackCancel()"
              (save)="onConnectSlackClick($event)"
            ></app-text-popup>
          </ng-template>
        </button>
      </div>
    </div>

    <div class="vertical basic-card-color purple-background full-width">
      <div class="title">Switch Workspaces</div>
      <app-workspace-list></app-workspace-list>
    </div>

    <!-- <div class="vertical">
        <div class="title">Init Data</div>
        <button class="fit-content" nz-button nzType="default" nzSize="default" (click)="onInitPersonalityClick()">
          Init Personality
        </button>
  
        <button class="fit-content" nz-button nzType="default" nzSize="default" (click)="onInitSalesCycleClick()">
          Init Sales Cycle
        </button>
      </div> -->
  </div>
</app-basic-page>

<nz-modal
  [(nzVisible)]="isConfigSalesCycleModalVisible"
  nzTitle="Config Sales Cycle"
  [nzWidth]="'800px'"
  [nzOkText]="'Save'"
  (nzOnOk)="onSaveConfigSalesCycleClick()"
  (nzOnCancel)="onCancelConfigSalesCycleClick()"
>
  <ng-container *nzModalContent>
    <div class="vertical full-width">
      <button class="right" nz-button nzType="primary" nzSize="default" (click)="onAddSaleCycleClick()">
        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
        Add Sales Cycle
      </button>

      <nz-table #basicTable [nzData]="workspace().settings?.salesCycleList ?? []" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Id</th>
            <th>Title</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track i; let i = $index) {
            <tr>
              <td>{{ data.id }}</td>
              <td>{{ data.title }}</td>
              <td>
                <button nz-button nzType="default" nzSize="small" (click)="onDeleteSaleCycleClick(i)">
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete_forever</span>
                  Delete
                </button>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </ng-container>
</nz-modal>

<app-sync-companies-hubspot [(isVisible)]="isSyncCompaniesHubspotVisible"></app-sync-companies-hubspot>
<app-sync-customers-hubspot [(isVisible)]="isSyncCustomersHubspotVisible"></app-sync-customers-hubspot>
